import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* ChemSafe Section */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">ChemSafe</h3>
            <p className="text-gray-400 text-sm">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/tools" className="text-gray-400 hover:text-white transition-colors duration-300">{t('footer.toolsResources')}</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300">{t('footer.aboutProject')}</Link></li>
              <li><Link to="/survey" className="text-gray-400 hover:text-white transition-colors duration-300">{t('footer.researchSurvey')}</Link></li>
            </ul>
          </div>          {/* Resources Section */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">{t('footer.resources')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/resources" className="text-gray-400 hover:text-white transition-colors duration-300">{t('footer.safetyResources')}</Link></li>
              <li><span className="text-gray-400">{t('footer.safetyGuidelines')}</span></li>
            </ul>
          </div>

          {/* IITM Logo Section */}
          <div className="col-span-1">
            <img src="/iitm_logo.png" className="h-16 w-auto" alt="IITM Logo" />
          </div>

          {/* Connect Section */}
          <div className="col-span-2">
            <h3 className="text-xl font-bold mb-4">{t('footer.connect')}</h3>
            <div className="flex items-center space-x-2 text-sm">
              <i className="fas fa-envelope"></i>
              <a href="mailto:chemsafe.iitm@gmail.com" className="text-gray-400 hover:text-white transition-colors duration-300">
                {t('home.email')}
              </a>
            </div>
          </div>
        </div>        {/* Bottom Section */}
        <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              {t('footer.copyright')}
            </div>
            <div className="flex space-x-4 text-gray-400 text-sm mb-4 md:mb-0">
              <Link to="/privacy-policy" className="hover:text-white transition-colors duration-300">
                {t('footer.privacyPolicy')}
              </Link>
              <Link to="/terms-of-use" className="hover:text-white transition-colors duration-300">
                {t('footer.termsOfUse')}
              </Link>
            </div>
            <div className="text-gray-400 text-sm">
              {t('footer.researchProject')}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
